import { render, staticRenderFns } from "./ModalNotas.vue?vue&type=template&id=c65715fa&scoped=true&"
import script from "./ModalNotas.vue?vue&type=script&lang=js&"
export * from "./ModalNotas.vue?vue&type=script&lang=js&"
import style0 from "./ModalNotas.vue?vue&type=style&index=0&id=c65715fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c65715fa",
  null
  
)

export default component.exports